import React from "react";

const TooltipContent = ({ type }) => {
  switch (type) {
    case "birthday-privacy":
      return (
        <>
          <p>Your birthday is private. It’s only used to
            personalize guidance based on your life stage—never shared.</p>
        </>
      );
    case "elements":
      return (
        <>
          <p>Explore your Periodic Table of the Self<span className="trademark">™</span> and deepen your self-knowledge.</p>
        </>
      );
    case "dialogues":
      return (
        <>
          <p>Start a live session with Aris—just you, with a connected relationship, or in a small <br />group (3–5).</p>
        </>
      );
    case "lock-icon":
      return (
        <>
          <p>Go incognito. These sessions aren't stored in history and are fully encrypted.</p>
        </>
      );
    case "microphone-icon":
      return (
        <>
          <p>Use voice-to-text to dictate your message—Aris will transcribe and respond.</p>
        </>
      );
    case "continue-session-icon":
      return (
        <>
          <p>Pick up where you left off – view, continue, rename, or delete past text dialogues.</p>
        </>
      );
    case "element-domains":
      return (
        <>

          <p>Select one or more domains to explore in your Periodic Table of the Self<span className="trademark">™</span>.
            Your Aris Elements<span className="trademark">™</span> will appear by activation level within each domain:</p>
          <ul>
            <li><strong>Identity</strong> – How you express yourself and connect with others.</li>
            <li><strong>Cognition</strong> – How you take in, process, and organize information</li>
            <li><strong>Judgment</strong> –  How you evaluate situations and make decisions.</li>
            <li><strong>Resolution</strong> – How you regulate emotions and navigate conflict.</li>
            <li><strong>Motivation</strong> – What energizes you, drives your behavior, and meets your core needs.</li>
          </ul>
        </>
      )
    case "Active":
      return (
        <p>Frequently influence your daily choices and interactions.</p>
      )
    case "Moderate":
      return (
        <p>Adjust fluidly based on context and environment.</p>
      )
    case "Subtle":
      return (
        <p>Less expressed now, but can grow with attention and
          experience.</p>
      )
    case "Primary":
      return (
        <p>Strongly and consistently drive your thoughts, feelings, and
          behaviors</p>
      )
    case 'unlimited_ai_chat':
      return (
        <p>Personalized, in-the-moment support—whenever you need it</p>
      )
    case 'periodic_table_of_self':
      return <p>Elevate your self-knowledge and decode how you think, feel, and grow</p>
    case 'mental_health_support':
      return <p>Build clarity, calm, and self-trust—especially in hard moments</p>
    case 'physical_health_support':
      return <p>Restore your rhythm, regulate energy, and reconnect with your body</p>
    case 'relational_health_support':
      return <p>Strengthen relationships, heal tension, and deepen communication</p>
    case 'blueprint':
      return <p>A personalized plan for sustainable, identity-aligned growth</p>
    case 'faith_and_belief_lens':
      return <p>Integrate your spiritual or philosophical traditions—optional, personalized, and always included</p>
    case 'faith-add':
      return <p>This will apply your selected faith system to every active membership you manage.</p>
    case "relationships":
    default:
      return (
        <>
          <p>Select a relationship to start a session with tailored topics—or type your own.</p>
        </>
      );
  }
};

export default TooltipContent;
